export default __webpack_public_path__ + "static/media/Kiunalla7.906e6048.jpg";